<script setup>
import { PhxTabPanel, PhxTabs } from '@phx-styleguides/iwc';
import { computed, ref, watchEffect } from 'vue';
import { getTabItemComponent, TABS_ORDER } from '@maison/helpers/search-helper';
import { get } from 'lodash-es';
import { useI18n } from 'vue-i18n';
import { PhxGridLayout } from '@sg/src/View/Components/Atoms/GridLayout';

const idPrefix = 'search-panel-empty-state';

const props = defineProps({
  items: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const currentTab = ref('');
const tabsTeleportTargetRef = ref(null);

const tabs = computed(() =>
  TABS_ORDER.map((tab) => ({
    tab,
    id: `${idPrefix}-tab-${tab}`,
    label: t(`Search.tab.${tab}`),
    items: get(props.items, tab, []),
    itemComponent: getTabItemComponent(tab),
  })).filter((tab) => tab.items.length > 0),
);

const onTabChange = (tab) => {
  currentTab.value = tab;
};

watchEffect(() => {
  currentTab.value = get(tabs.value, '0.id', '');
});
</script>

<template>
  <div>
    <div class="search-panel__tabs-wrapper">
      <phx-tabs
        v-cloak
        :id="`${idPrefix}-tabs`"
        class="tabs-group--with-indicator"
        theme="light"
        layout="start"
        :value="currentTab"
        :indicator-thickness="1"
        :teleport-target="tabsTeleportTargetRef"
        @change="onTabChange"
      >
        <phx-tab-panel v-for="tab in tabs" :id="tab.id" :key="tab.id" :label="tab.label">
          <phx-grid-layout class="mixed-grid" grid-spacing="4" :center-spacing="null">
            <component :is="tab.itemComponent" v-for="(item, key) in tab.items" :key="tab.id + key" v-bind="item" />
          </phx-grid-layout>
        </phx-tab-panel>
      </phx-tabs>
    </div>

    <div ref="tabsTeleportTargetRef" class="search-panel__tabs-content"></div>
  </div>
</template>
